import React, { useEffect, useState } from "react";
import styles from "./AdminAnalytics.module.scss";
import {
  AdminLicenseHolder,
  loadAdminAnalytics,
} from "./admin-real-data.service";
import CustomerEngagementTable from "./admin-components/CustomerEngagementTable";

// ============================================================
// Customers tab — every license-holder, surfaced via the same
// CustomerEngagementTable that previously lived on the Analytics tab.
// Quick Views (Top Recent / New Accounts / Gone Stale / Hot Trials /
// At-Risk Renewals), per-column filters, aggregate row, link-status
// pills, comms column — all inherited from the shared component.
// ============================================================

const AdminCustomers: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [holders, setHolders] = useState<AdminLicenseHolder[]>([]);

  useEffect(() => {
    let cancelled = false;
    loadAdminAnalytics()
      .then((bundle) => {
        if (cancelled) return;
        setHolders(bundle.holders);
      })
      .catch((e) => {
        console.error("Failed to load customers", e);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className={styles.page}>
        <div className={styles.loading}>Loading customers...</div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div>
          <h1 className={styles.title}>Customers</h1>
          <p className={styles.subtitle}>
            Every license holder. Pick a Quick View to slice the list, or
            search/sort/customize columns. 7d / 90d / prev-90d question
            counts come from the raw question_statistic event log (live, not
            snapshot-derived). Comms column merges HubSpot historical
            engagement with platform send-log records.
          </p>
        </div>
      </div>

      <div className={styles.card} style={{ marginBottom: 16 }}>
        <CustomerEngagementTable holders={holders} />
      </div>
    </div>
  );
};

export default AdminCustomers;
